/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tts_Tool_DownloadInputs */

const en_tts_tool_download = /** @type {(inputs: Tts_Tool_DownloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download`)
};

const es_tts_tool_download = /** @type {(inputs: Tts_Tool_DownloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descargar`)
};

/**
* | output |
* | --- |
* | "Download" |
*
* @param {Tts_Tool_DownloadInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const tts_tool_download = /** @type {((inputs?: Tts_Tool_DownloadInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tts_Tool_DownloadInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tts_tool_download(inputs)
	return en_tts_tool_download(inputs)
});